module.exports = __webpack_public_path__ + "img/i18n-flow-chart.e671223e.png";